var map = {
	"./EVO.png": 1550,
	"./Path 20295.png": 1551,
	"./ab-img.webp": 1552,
	"./ab-title-cn.webp": 1553,
	"./ab-title-en.webp": 1554,
	"./ag-img.png": 1555,
	"./ag-img.webp": 1556,
	"./ag-title-cn.webp": 1557,
	"./ag-title-en.webp": 1558,
	"./chess-img.webp": 1559,
	"./coin-img.webp": 1560,
	"./content-img.webp": 1561,
	"./dg-img.webp": 1562,
	"./dg-title-cn.webp": 1563,
	"./dg-title-en.webp": 1564,
	"./diamond-img.webp": 1565,
	"./dice-coin.webp": 1566,
	"./ea-img.webp": 1567,
	"./ea-title-cn.webp": 1568,
	"./ea-title-en.webp": 1569,
	"./evo-img.webp": 1570,
	"./evo-title-cn.webp": 1571,
	"./evo-title-en.webp": 1572,
	"./golddice-img.webp": 1573,
	"./gp-img.webp": 1574,
	"./gp-title-cn.webp": 1575,
	"./gp-title-en.webp": 1576,
	"./heart-coin-img.webp": 1577,
	"./lc-bg.webp": 1578,
	"./mg-img.webp": 1579,
	"./mg-title-cn.webp": 1580,
	"./mg-title-en.webp": 1581,
	"./pp-img.webp": 1582,
	"./pp-title-cn.webp": 1583,
	"./pp-title-en.webp": 1584,
	"./pt-img.webp": 1585,
	"./pt-title-cn.webp": 1586,
	"./pt-title-en.webp": 1587,
	"./sa-img.webp": 1588,
	"./sa-title-cn.webp": 1589,
	"./sa-title-en.webp": 1590,
	"./sbo-img.webp": 1591,
	"./sbo-title-cn.webp": 1592,
	"./sbo-title-en.webp": 1593,
	"./spade-img.webp": 1594,
	"./title-cn.webp": 1595,
	"./title-en.webp": 1596,
	"./white-spade-img.webp": 1597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1549;